import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../../enums';
import { beforeEnter } from '../guards/index';

const Update = () => import('./Update.vue');

export const updateRoute: RouteRecordRaw = {
  path: buildChildURL(DiscountsRoutePathNames.UPDATE),
  name: DiscountsRouteNames.DISCOUNTS_UPDATE,
  component: Update,
  beforeEnter: beforeEnter,
};
